module.exports = __webpack_public_path__ + "static/media/patient_comparison_x-ray.2117780e.png";